module.exports = __webpack_public_path__ + "img/upload-doc.483826af.svg";